import type { FC, ReactNode } from "react";

import { Badge } from "./Badge";
import { ContentCard } from "./ContentCard";
import { DataState } from "./DataState";
import { Pagination } from "./Pagination";
import { SectionHeader } from "./SectionHeader";

export interface EntriesTableShellProps {
  title?: string;
  total: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  errorMessage?: string | null;
  isEmpty: boolean;
  emptyTitle: string;
  emptyDescription: string;
  onPageChange: (page: number) => void;
  children: ReactNode;
}

export const EntriesTableShell: FC<EntriesTableShellProps> = ({
  title = "Entries",
  total,
  page,
  pageSize,
  isLoading,
  errorMessage,
  isEmpty,
  emptyTitle,
  emptyDescription,
  onPageChange,
  children,
}) => (
  <div className="space-y-3">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <SectionHeader title={title} />
      <Badge variant="default" size="md">
        {total.toLocaleString()} total
      </Badge>
    </div>

    <ContentCard padding="none" className="dark:bg-black/20">
      <DataState
        loading={isLoading}
        error={errorMessage ?? null}
        empty={isEmpty}
        emptyTitle={emptyTitle}
        emptyDescription={emptyDescription}
        className="p-4"
      >
        <div className="space-y-3">
          {children}

          <Pagination
            page={page}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
          />
        </div>
      </DataState>
    </ContentCard>
  </div>
);
